"use client";

import { Trans, useTranslation } from "react-i18next";
import { Heart, Gitlab, BookOpen, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const EthicsSection = () => {
  const { t } = useTranslation();

  return (
    <section id="ethics" className="py-24 relative overflow-hidden">
      <div className="absolute top-1/2 -translate-y-1/2 -left-32 w-96 h-96 bg-secondary/15 blob-shape animate-blob-morph blur-3xl" />
      <div
        className="absolute top-10 right-0 w-72 h-72 bg-accent/10 blob-shape animate-blob-morph blur-3xl"
        style={{ animationDelay: "3s" }}
      />

      <div className="container mx-auto px-6 relative">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-primary/20 border-2 border-primary mb-8">
            <Heart className="w-10 h-10 text-primary fill-primary" aria-hidden="true" />
          </div>

          <h2 className="font-heading font-bold text-4xl md:text-5xl mb-5 leading-tight">
            <Trans
              i18nKey="ethics.title"
              components={{
                br: <br />,
                gradient: <span className="text-gradient" />,
              }}
            />
          </h2>
          <p className="text-muted-foreground text-lg mb-10 leading-relaxed">
            <Trans
              i18nKey="ethics.description"
              components={{
                br: <br />,
                strong: <strong className="text-foreground" />,
              }}
            />
          </p>

          <div className="flex flex-wrap gap-3 justify-center">
            <Button variant="hero" size="lg" asChild>
              <a
                href={process.env.NEXT_PUBLIC_GITLAB_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2"
              >
                <Gitlab className="w-5 h-5" aria-hidden="true" />
                {t("ethics.sourceCode")}
              </a>
            </Button>
            <Button variant="outline" size="lg" asChild>
              <a
                href={process.env.NEXT_PUBLIC_DOCS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2"
              >
                <BookOpen className="w-5 h-5" aria-hidden="true" />
                {t("ethics.documentation")}
              </a>
            </Button>
            <Button variant="outline" size="lg" asChild>
              <a
                href={process.env.NEXT_PUBLIC_DISCORD_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2"
              >
                <MessageCircle className="w-5 h-5" aria-hidden="true" />
                {t("ethics.discord")}
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EthicsSection;
